<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-list-item-title class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-property">
            <v-text-field
                    label="Entrypoint"
                    :disabled="readOnly"
                    v-model="value.object.spec.entrypoint"
            ></v-text-field>
            <v-text-field
                    label="Template Name"
                    :disabled="readOnly"
                    v-model="value.object.spec.templates[0].name"
            ></v-text-field>
            <v-btn
                    v-if="value.workflowType"
                    dark rounded color="primary"
                    :disabled="readOnly"
                    @click="addProperty"
                    style="margin-bottom: 15px;">
                <label v-if="value.workflowType == 'steps'">ADD STEP</label>
                <label v-if="value.workflowType == 'dag'">ADD TASK</label>
            </v-btn>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        mixins: [KubernetesPanel],
        name: 'workflow-property-panel',
        computed: {
            descriptionText() {
                return 'Workflow'
            },
        },
        data: function () {
            return {}
        },
        watch: {
        },
        methods: {
            addProperty() {
                var me = this;
                var attrList = Object.entries(me.value.advancedAttributePaths);
                attrList.forEach(([key, value]) => {
                    me.attrKey = key;
                    me.attrVal = value;
                });
                me.value.object.metadata.generateName = me.value.object.metadata.generateName + ",";
                me.$nextTick(function () {
                    _.set(me.value.object, me.attrKey, me.attrVal);
                    me.value.object.metadata.generateName = (me.value.object.metadata.generateName).replace(',', '');
                });
            }
        }
    }
</script>


